import AssetTypePicker from './AssetTypePicker';

export default AssetTypePicker;
